import React from "react";
import {
  Button
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  KeyboardBackspace
} from "@mui/icons-material";
import {getImage} from "../../../../../utils/image";
import {useHistory} from "react-router-dom";

const HeadElement = ({iconId, name}) => {
  const classes = useStyles();
  const history = useHistory();
  const handleGoBack = () => {
    history.goBack();
  }
  return (
    <div className={classes.root}>
      <Button className={classes.goBack} onClick={handleGoBack}>
        <KeyboardBackspace sx={{color: "white"}}/>
      </Button>
      <div className={classes.mainContent}>
        <div className={classes.logo}>
          <img src={getImage(iconId, {height: '48px'})}/>
        </div>
        <div className={classes.name}>{name}</div>
      </div>
      <div className={classes.goBack}/>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
  },
  goBack: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 40,
    padding: 0,
    minWidth: "initial",
    background: "transparent!important"
  },
  mainContent: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 48,

    "& img": {
      height: "100%",
      maxWidth: "100%",
      transform: "scale(1.1)",
    }
  },
  name: {
    marginTop: "8px",

    fontSize: 20,
    color: "white",
    fontWeight: "500",
    lineHeight: "24px",
    textAlign: "center",
  }
}));

export default HeadElement
